import { authApi } from '@/api/authApi';
import { facilitiesApi } from '@/api/facilitiesApi';
import { portfolioApi } from '@/api/portfolioApi';
import { syncDataApi } from '@/api/syncDataApi';
import { clearSentryUser, setSentryUser } from '@/utils/sentry';
import { createSlice } from '@reduxjs/toolkit';

// Initial state - token and user data
const initialState = {
  token: null,
  user: null,
};

const authSlice = createSlice({
  name: 'apiToken',
  initialState,
  reducers: {
    setToken(state, action) {
      state.token = action.payload;
    },
    clearToken(state) {
      state.token = null;
      state.user = null;
      clearSentryUser();
    },
  },
  extraReducers: (builder) => {
    // Sync user data from API to slice
    builder.addMatcher(authApi.endpoints.getCurrentUser.matchFulfilled, (state, action) => {
      state.user = action.payload;
      setSentryUser(action.payload);
    });

    // Clear user when API call fails
    builder.addMatcher(authApi.endpoints.getCurrentUser.matchRejected, (state) => {
      state.user = null;
      clearSentryUser();
    });
  },
});

// Thunk to clear token and reset all API caches
export const logout = () => (dispatch) => {
  dispatch(clearToken());
  // Reset all RTK Query API caches
  dispatch(authApi.util.resetApiState());
  dispatch(facilitiesApi.util.resetApiState());
  dispatch(portfolioApi.util.resetApiState());
  dispatch(syncDataApi.util.resetApiState());
};

export const { setToken, clearToken } = authSlice.actions;
export default authSlice.reducer;
